import { useMemberApi } from "@xemplo/gp-api";
import { getHook, setHook } from "react-hooks-outside";

setHook("memberApi", useMemberApi);
export const memberApi = () =>
  getHook("memberApi") as ReturnType<typeof useMemberApi>;
